"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemsPerPageOptions = exports.TableFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _tableFooterModule = _interopRequireDefault(require("./table-footer.module.scss"));
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _Select = require("../../../elements/select/select/Select");
var _Paging = require("../paging/Paging");
var itemsPerPageOptions = [{
  label: '10 items',
  value: '10'
}, {
  label: '25 items',
  value: '25'
}, {
  label: '50 items',
  value: '50'
}, {
  label: '100 items',
  value: '100'
}];
exports.itemsPerPageOptions = itemsPerPageOptions;
var TableFooter = function TableFooter(_ref) {
  var pageSize = _ref.pageSize,
    totalItemsCount = _ref.totalItemsCount,
    totalPageCount = _ref.totalPageCount,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    changePageSize = _ref.changePageSize,
    changeCurrentPage = _ref.changeCurrentPage,
    dataName = _ref.dataName;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var pageStart = (currentPage - 1) * pageSize + 1;
  var pageEnd = Math.min((currentPage - 1) * pageSize + pageSize, totalItemsCount);
  var onSizeChange = function onSizeChange(_ref2) {
    var value = _ref2.currentTarget.value;
    changePageSize(Number(value));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _tableFooterModule.default['table-footer']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _tableFooterModule.default['table-footer__size-controls']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _tableFooterModule.default['table-footer__select-container']
  }, /*#__PURE__*/_react.default.createElement(_Select.Select, {
    value: pageSize.toString(),
    className: _tableFooterModule.default['table-footer__items-select'],
    id: "items-per-page",
    name: "items-per-page",
    onChange: onSizeChange,
    menuPlacement: "top",
    small: true,
    options: itemsPerPageOptions
  })), totalItemsCount ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: _tableFooterModule.default['table-footer__showing-info']
  }, t('tableFooter.showing', {
    dataName: dataName,
    pageStart: pageStart,
    pageEnd: pageEnd,
    totalItemsCount: totalItemsCount
  }))) : null), totalPageCount !== undefined ? /*#__PURE__*/_react.default.createElement(_Paging.Paging, {
    page: currentPage,
    totalPages: totalPageCount,
    changeCurrentPage: changeCurrentPage
  }) : /*#__PURE__*/_react.default.createElement(_Paging.Paging.Loading, null));
};
exports.TableFooter = TableFooter;